import React from "react";
import Banner from "../../../assets/images/banner1.png";
import { MdPhoneInTalk } from "react-icons/md";

function Middlebanner() {
  return (
    <div
      className="bg-cover bg-center rounded-2xl grid grid-cols-2 mx-4 md:mx-8 lg:mx-12"
      style={{ backgroundImage: `url(${Banner})` }}
    >
      {/* <img src={Banner} alt="" className='xl:px-14 pt-12 lg:px-12 md:px-12 px-2'/> */}
      <div>
        <h1 className="text-xs md:text-xl xl:text-3xl text-white font-bold px-4 md:px-12 py-4 md:py-12 lg:py-16">
          "Experience the Fastest and Most Affordable Fastag Services with Us!"
        </h1>
      </div>
      <div className="flex justify-start items-center">
        <div className="flex border border-[#F26422] border-1 rounded-full py-0 items-center gap-0 md:gap-4">
          <MdPhoneInTalk className="text-[#214293] text-2xl md:text-5xl lg:text-7xl bg-[#F26422] p-3 rounded-full" />
          <h2 className="text-white md:font-bold text-sm md:text-2xl lg:text-3xl pr-1 md:pr-4 lg:pr-12">
            +91 9124578108
          </h2>
        </div>
      </div>
    </div>
  );
}

export default Middlebanner;
